module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-142.538672e.woff2";